import { makeAutoObservable } from 'mobx'
import CourtEntity from "../../courts/entities/court.entity";

export default class MapStore {
  constructor () {
    makeAutoObservable(this)
  }

  lat: number = 39.0997
  lng: number = -94.5786
  searchTerm: string = ''
  courts: CourtEntity[] = []
  selectedCourt: CourtEntity = new CourtEntity()
  courtsLoading: boolean = false
  showCourtPopup: boolean = false
  singleCourts: Map<string, CourtEntity> = new Map<string, CourtEntity>()
}
